import React from 'react';
import { monthDayTime, prettyDate } from '@/utils/dates';
import EnterFullScreenIcon from '@/components/ui/icons/EnterFullScreenIcon';
import CopyToClipboard from '@/components/ui/shared/CopyToClipboard';
import Dotmenu from '@/components/shadcn/dotmenu';
import { useAlmanac } from '@/hooks/useAlmanac';
import { cn } from '@/utils/styles';
import CloseIcon from '../../icons/CloseIcon';

interface Props {
  setShowModal: (show: boolean) => void;
  onDotClick: (index: number) => void;
  showDateAndDotMenu: boolean;
}

export default function Overlay({
  setShowModal,
  onDotClick,
  showDateAndDotMenu,
}: Props) {
  const {
    activeFrameIndex,
    sortedSequences,
    activeSequenceIndex,
    setActiveLocation,
  } = useAlmanac();

  const activeFrame = sortedSequences[activeSequenceIndex]?.[activeFrameIndex];
  if (!activeFrame) return null;

  return (
    <>
      <div
        className={cn(
          'absolute left-2 top-2 z-10 flex cursor-pointer items-center rounded-md bg-neutral-1000/65 px-1.5 py-1 font-lato text-xs group-hover:opacity-100 opacity-0',
          { 'opacity-100': showDateAndDotMenu },
        )}>
        <div>
          {prettyDate(activeFrame?.timestamp, true)}
          {', '}
          {monthDayTime(new Date(activeFrame?.timestamp))}
        </div>
      </div>

      <div className="absolute right-2 top-2 z-10 flex gap-1.5  opacity-0 group-hover:opacity-100">
        <div
          className="cursor-pointer rounded-lg bg-neutral-1000/65 p-1 transition-colors hover:bg-neutral-1000/80"
          onClick={() => setShowModal(true)}>
          <EnterFullScreenIcon className="fill-neutral-0" />
        </div>
        <div
          className=" cursor-pointer rounded-lg bg-neutral-1000/65 p-1 transition-colors hover:bg-neutral-1000/80"
          onClick={() => setActiveLocation(undefined)}>
          <CloseIcon className="fill-neutral-0" />
        </div>
      </div>

      {activeFrame?.position && (
        <div className="absolute bottom-2 left-2 z-10 flex items-center rounded-md bg-neutral-1000/65 px-1.5 py-1 font-lato text-xs opacity-0 group-hover:opacity-100">
          <div className="mr-2">Lat/Long</div>
          <CopyToClipboard
            content={`${activeFrame?.position.lat}, ${activeFrame?.position.lon}`}
            iconClassName="size-3"
          />
        </div>
      )}

      <div
        className={cn(
          'absolute bottom-0 left-1/2 z-10 -translate-x-1/2 opacity-0 group-hover:opacity-100',
          { 'opacity-100': showDateAndDotMenu },
        )}>
        <Dotmenu
          totalDots={sortedSequences.length}
          activeDotIndex={activeSequenceIndex}
          onDotClick={onDotClick}
        />
      </div>
    </>
  );
}
